import {Injectable} from "@angular/core";

@Injectable()
export class NarrativeStylingService {
    getStyle(value) {
        if (value === "4") {
            return 'strength';
        }
        if (value === "3") {
            return 'three';
        }
        if (value === "2") {
            return 'two';
        }
        if (value === "1") {
            return 'one';
        }
        if (value === "0") {
            return 'one';
        }
        if (value === "") {
            return 'one';
        }

        return "";
    }
}